import { PROFFIT_TOP_COMPANY_LOGO_ASTELLAS, PROFFIT_TOP_COMPANY_LOGO_CHUGAISEIYAKU, PROFFIT_TOP_COMPANY_LOGO_DAIICHISANKYO, PROFFIT_TOP_COMPANY_LOGO_DOCOMO, PROFFIT_TOP_COMPANY_LOGO_FAMILYMART, PROFFIT_TOP_COMPANY_LOGO_FUJIFILM, PROFFIT_TOP_COMPANY_LOGO_IHI, PROFFIT_TOP_COMPANY_LOGO_JT, PROFFIT_TOP_COMPANY_LOGO_KANEBO, PROFFIT_TOP_COMPANY_LOGO_KAO, PROFFIT_TOP_COMPANY_LOGO_MARUBENI, PROFFIT_TOP_COMPANY_LOGO_MARUHAN, PROFFIT_TOP_COMPANY_LOGO_MEIJI, PROFFIT_TOP_COMPANY_LOGO_MITSUBISHI, PROFFIT_TOP_COMPANY_LOGO_MITSUIBUSSAN, PROFFIT_TOP_COMPANY_LOGO_NISSAN, PROFFIT_TOP_COMPANY_LOGO_NTTCOM, PROFFIT_TOP_COMPANY_LOGO_PANASONIC, PROFFIT_TOP_COMPANY_LOGO_RECRUIT, PROFFIT_TOP_COMPANY_LOGO_RAKUTEN, PROFFIT_TOP_COMPANY_LOGO_SONY, PROFFIT_TOP_COMPANY_LOGO_SUMITOMOSYOUZI, PROFFIT_TOP_COMPANY_LOGO_TOYOTA, } from '@/utils/constants/assets/s3';
/** 企業のロゴ */
export const topCompanyLogoData = [
    {
        alt: 'アステラス製薬株式会社',
        height: 130,
        src: PROFFIT_TOP_COMPANY_LOGO_ASTELLAS.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_ASTELLAS.webp,
        width: 470,
    },
    {
        alt: '中外製薬株式会社',
        height: 122,
        src: PROFFIT_TOP_COMPANY_LOGO_CHUGAISEIYAKU.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_CHUGAISEIYAKU.webp,
        width: 300,
    },
    {
        alt: '第一三共株式会社',
        height: 54,
        src: PROFFIT_TOP_COMPANY_LOGO_DAIICHISANKYO.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_DAIICHISANKYO.webp,
        width: 345,
    },
    {
        alt: '株式会社NTTドコモ',
        height: 62,
        src: PROFFIT_TOP_COMPANY_LOGO_DOCOMO.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_DOCOMO.webp,
        width: 300,
    },
    {
        alt: '株式会社ファミリーマート',
        height: 130,
        src: PROFFIT_TOP_COMPANY_LOGO_FAMILYMART.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_FAMILYMART.webp,
        width: 450,
    },
    {
        alt: '富士フイルム株式会社',
        height: 82,
        src: PROFFIT_TOP_COMPANY_LOGO_FUJIFILM.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_FUJIFILM.webp,
        width: 300,
    },
    {
        alt: '株式会社IHI',
        height: 132,
        src: PROFFIT_TOP_COMPANY_LOGO_IHI.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_IHI.webp,
        width: 419,
    },
    {
        alt: '日本たばこ産業株式会社',
        height: 130,
        src: PROFFIT_TOP_COMPANY_LOGO_JT.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_JT.webp,
        width: 280,
    },
    {
        alt: '株式会社カネボウ化粧品',
        height: 85,
        src: PROFFIT_TOP_COMPANY_LOGO_KANEBO.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_KANEBO.webp,
        width: 300,
    },
    {
        alt: '花王株式会社',
        height: 212,
        src: PROFFIT_TOP_COMPANY_LOGO_KAO.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_KAO.webp,
        width: 387,
    },
    {
        alt: '丸紅株式会社',
        height: 30,
        src: PROFFIT_TOP_COMPANY_LOGO_MARUBENI.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_MARUBENI.webp,
        width: 291,
    },
    {
        alt: '株式会社マルハン',
        height: 104,
        src: PROFFIT_TOP_COMPANY_LOGO_MARUHAN.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_MARUHAN.webp,
        width: 535,
    },
    {
        alt: '株式会社明治',
        height: 122,
        src: PROFFIT_TOP_COMPANY_LOGO_MEIJI.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_MEIJI.webp,
        width: 300,
    },
    {
        alt: '三菱商事株式会社',
        height: 102,
        src: PROFFIT_TOP_COMPANY_LOGO_MITSUBISHI.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_MITSUBISHI.webp,
        width: 503,
    },
    {
        alt: '三井物産株式会社',
        height: 121,
        src: PROFFIT_TOP_COMPANY_LOGO_MITSUIBUSSAN.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_MITSUIBUSSAN.webp,
        width: 621,
    },
    {
        alt: '日産自動車株式会社',
        height: 263,
        src: PROFFIT_TOP_COMPANY_LOGO_NISSAN.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_NISSAN.webp,
        width: 302,
    },
    {
        alt: 'エヌ・ティ・ティ・コミュニケーションズ株式会社',
        height: 126,
        src: PROFFIT_TOP_COMPANY_LOGO_NTTCOM.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_NTTCOM.webp,
        width: 500,
    },
    {
        alt: 'パナソニック株式会社',
        height: 106,
        src: PROFFIT_TOP_COMPANY_LOGO_PANASONIC.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_PANASONIC.webp,
        width: 711,
    },
    {
        alt: '会社概要リクルート',
        height: 74,
        src: PROFFIT_TOP_COMPANY_LOGO_RECRUIT.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_RECRUIT.webp,
        width: 280,
    },
    {
        alt: '楽天グループ株式会社',
        height: 130,
        src: PROFFIT_TOP_COMPANY_LOGO_RAKUTEN.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_RAKUTEN.webp,
        width: 428,
    },
    {
        alt: 'ソニー株式会社',
        height: 92,
        src: PROFFIT_TOP_COMPANY_LOGO_SONY.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_SONY.webp,
        width: 500,
    },
    {
        alt: '住友商事株式会社',
        height: 48,
        src: PROFFIT_TOP_COMPANY_LOGO_SUMITOMOSYOUZI.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_SUMITOMOSYOUZI.webp,
        width: 300,
    },
    {
        alt: 'トヨタ自動車株式会社',
        height: 97,
        src: PROFFIT_TOP_COMPANY_LOGO_TOYOTA.base,
        webpSrc: PROFFIT_TOP_COMPANY_LOGO_TOYOTA.webp,
        width: 500,
    },
];
